<template>
	<b-modal
		id="deploy-dispatch"
		:title="title"
		ok-title="Proceed"
		ref="modal"
		@ok="handleOk"
		:cancel-disabled="disableConfirmButtons"
		:ok-disabled="disableConfirmButtons"
		:no-close-on-backdrop="true"
	>
		<loading
			:active.sync="isLoading"
			loader="spinner"
			color="#20A8D8"
			:is-full-page="false"
		/>

		<div class="confirmMessage">
			Are you sure you want to deploy
			<b>{{ selDispatch.dispatchId }}</b>
			?
		</div>
	</b-modal>
</template>

<script>
// Util
import { DateUtil } from '@/utils/dateutil';
import { LocationUtil } from '@/utils/locationUtil';
import { DispatchUtil } from '@/utils/dispatchUtil';

// API
import dispatchApi from '@/api/dispatchApi';

// Others
import EventBus from '@/shared/event-bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	name: 'deploy-dispatch',
	components: {
		Loading,
	},
	data() {
		return {
			selDispatch: {},
			loggedUser: this.$store.getters.loggedUser,
			// Check for loader
			isLoading: false,
		};
	},
	computed: {
		title() {
			return 'Deploy Dispatch ' + this.selDispatch.dispatchId;
		},
		disableConfirmButtons() {
			return this.isLoading;
		},
	},
	mounted() {
		EventBus.$on('onUpdateSelDispatch', (selDispatch) => {
			if (!_.isEmpty(selDispatch)) {
				this.selDispatch = DispatchUtil.cleanupFields(selDispatch);
			}
		});
	},
	methods: {
		async handleOk(evt) {
			// Prevent modal from closing
			evt.preventDefault();

			// show loading indicator
			this.isLoading = true;

			// update fields
			this.selDispatch.dateDeployed = DateUtil.getCurrentTimestamp();
			this.selDispatch.deployedBy = this.loggedUser.id;

			// update geoaddresses
			this.selDispatch.source.geoaddress = LocationUtil.getGeoaddress(
				this.selDispatch.source.geoaddress
			);
			this.selDispatch.destination.geoaddress = LocationUtil.getGeoaddress(
				this.selDispatch.destination.geoaddress
			);

			if (this.selDispatch.transportation) {
				let transportation = this.selDispatch.transportation;
				if (transportation && transportation.pickUpPoint)
					this.selDispatch.transportation.pickUpPoint = LocationUtil.getGeoaddress(transportation.pickUpPoint);

				if (transportation && transportation.dropOffPoint)
					this.selDispatch.transportation.dropOffPoint = LocationUtil.getGeoaddress(transportation.dropOffPoint);
			}

			// Require the dispatch to have at least 1 selected asset before deployment
			if (!this.selDispatch.assets || this.selDispatch.assets.length === 0) {
				this.$toaster.warning(
					`Dispatch "${this.selDispatch.dispatchId}" should have at least 1 asset before deployment.`
				);

				// hide loading indicator
				this.isLoading = false;
				return;
			}

			let dispatchId = this.selDispatch.dispatchId;
			try {
				let { data } = await dispatchApi.deployDispatch(
					this.selDispatch,
					this.loggedUser.id
				);

				if (data.isSuccess) {
					this.$toaster.success(
						`Dispatch "${dispatchId}" was deployed successfully.`
					);
					this.$refs.modal.hide();
					EventBus.$emit('onCloseDeployDispatch', data.dispatch);
				} else {
					// hide loading indicator
					this.isLoading = false;
					this.$toaster.warning(data.message);
				}
			} catch (error) {
				// hide loading indicator
				this.isLoading = false;
				this.$toaster.error(
					`Error deploying dispatch ${dispatchId}. Please try again.`
				);
			}
		},
	},
	beforeDestroy() {
		EventBus.$off('onUpdateSelDispatch');
	},
};
</script>

